module.exports = __webpack_public_path__ + "img/em_manutencao.73933395.png";